import React from "react";
import { useAuth0 } from "@auth0/auth0-react";

const LogoutButton = ({ closeDropdown, className }) => {
  const { logout } = useAuth0();

  return (
    <button
      className={className}
      onClick={() => {
        logout({
          logoutParams: { returnTo: process.env.REACT_APP_LOGOUT_RETURN_URL },
        }); // Update the returnTo URL
        closeDropdown();
      }}
    >
      Log Out
    </button>
  );
};

export default LogoutButton;
